module.exports = __webpack_public_path__ + "painelusyvyys.png?2d06da06babbfa080a6f8a5f35deb639";


//////////////////
// WEBPACK FOOTER
// ./src/assets/painelusyvyys.png
// module id = 323
// module chunks = 0